/*
* @Author: 王春岩 <Bolt>
* @Date:   2017-05-16 16:06:38
* @Last Modified by:   Bolt
* @Last Modified time: 2017-05-16 20:07:47
*/

'use strict';

import {
    jsonpInstance
} from './_instance.js';

export function addUserInfo2Cookie(userPhone) {
    return jsonpInstance('/api/userApi/addUserInfo2Cookie.jsonp', {
        userPhone
    });
}

export function getUserTag() {
    return jsonpInstance('/api/userapi/getUserTag.jsonp', {
        isSaveCookie: 1
    });
}



// WEBPACK FOOTER //
// ./src/api/from-traffic/userApi.js